export default __webpack_public_path__ + "static/media/tv.1836b623.svg";